import Route from "../../../router/Route";
import Index from "@/modules/pqa/pages/Index.vue";
import ImportSteeringRules from "@/modules/pqa/pages/ImportSteeringRules.vue";
import PqaRuleEngine from "@/modules/pqa/pages/PqaRuleEngine.vue";
import PqaRuleEngineVersions from "@/modules/pqa/pages/PqaRuleEngineVersions.vue";
import PqaRuleEngineBuilder from "@/modules/pqa/pages/PqaRuleEngineBuilder.vue";

export default new Route(
	"pqa",
	"/pqa",
	Index,
	[
		new Route("pqa.steering-rules", "steering-rules", ImportSteeringRules, []),
		new Route("pqa.rules", "rules", PqaRuleEngine, [
			new Route(
				"pqa.rules.versions",
				"versions/:model_uuid",
				PqaRuleEngineVersions,
				[]
			),
			new Route(
				"pqa.rules.builder",
				"builder/:model_uuid/:version_uuid/:displayed_ruleset_uuid?",
				PqaRuleEngineBuilder,
				[]
			),
		]),
	],
	{ permissions: ["can_manage_pqa"] },
	"/pqa/steering-rules"
);